// Simple logger fallback for standalone library
const logger = {
    log: (context, ...args) => {
        console.log(`[${context}]`, ...args);
    },
    error: (context, ...args) => {
        console.error(`[${context}]`, ...args);
    }
};

const API_BASE = 'http://localhost:5555/api';

export async function disconnectWiFi () {
    try {
        logger.log('BrightSign', 'Attempting to disconnect WiFi...');

        const response = await fetch(`${API_BASE}/hardware/disconnect-wifi`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();

        if (data.success) {
            logger.log('BrightSign', 'WiFi disconnected successfully');
            return true;
        } else {
            logger.error('BrightSign', 'Failed to disconnect WiFi', data.error);
            return false;
        }
    } catch (error) {
        logger.error('BrightSign', 'Failed to disconnect WiFi', error);
        return false;
    }
}

export async function reboot () {
    try {
        logger.log('BrightSign', 'Initiating device reboot...');

        const response = await fetch(`${API_BASE}/hardware/reboot`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();

        if (data.success) {
            logger.log('BrightSign', 'Reboot command sent successfully');
            return true;
        } else {
            logger.error('BrightSign', 'Failed to reboot device', data.error);
            return false;
        }
    } catch (error) {
        logger.error('BrightSign', 'Failed to reboot device', error);
        return false;
    }
}

export async function disconnectAndReboot () {
    try {
        logger.log('BrightSign', 'Starting WiFi reset workflow');

        const response = await fetch(`${API_BASE}/hardware/disconnect-and-reboot`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();

        if (data.success) {
            logger.log('BrightSign', 'WiFi reset workflow completed successfully');
            return true;
        } else {
            logger.error('BrightSign', 'WiFi reset workflow failed', data.error);
            return false;
        }
    } catch (error) {
        logger.error('BrightSign', 'WiFi reset workflow failed', error);
        return false;
    }
}

export async function getSystemMetrics () {
    try {
        const response = await fetch(`${API_BASE}/system/metrics`);
        const data = await response.json();
        return data;
    } catch (error) {
        logger.error('BrightSign', 'Failed to fetch system metrics', error);
        return null;
    }
}

export async function getPrometheusMetrics () {
    try {
        const response = await fetch(`${API_BASE}/metrics`);
        if (!response.ok) return null;
        return await response.text();
    } catch (error) {
        logger.error('BrightSign', 'Failed to fetch prometheus metrics', error);
        return null;
    }
}
